import arcoAjuda from "./arco-ajuda.webp";
import arcoAmeaca from "./arco-ameaca.webp";
import { CARDS_COMUNS_SUL, CARDS_RAROS_SUL } from "./cartas";
import fundoColecao from "./colecao.webp";
import mascoteCabeca from "./mascote-cabeca.webp";
import mascoteCorpo from "./mascote-corpo.webp";
import fundoSelecao from "./selecao.webp";
import fundoDesfocado from "./tabuleiro-desfocado.webp";
import fundoTabuleiro from "./tabuleiro.webp";

// Região SUL, bioma Pampa, mascote Gato-palheiro.
//
// O id é `sul`, e não `pampa`: a região geográfica É a região do bioma, e há um nome
// só. "Pampa" é o `bioma`, rótulo que o aluno lê.
//
// É a região de CAMPO ABERTO, e isso muda o conteúdo em relação às outras quatro: lá
// o vilão típico é "derrubaram a árvore", aqui é "araram o campo" ou "plantaram
// árvore onde não havia". O gato-palheiro depende de capim alto para se esconder e
// caçar, então quase tudo nos 22 textos gira em torno de manter o campo nativo de pé.

export const MASCOTE_SUL = {
  // O nome da ESPÉCIE, como no Centro-Oeste e pela mesma razão: é assim que os 22
  // textos aprovados o chamam. O MD registra a escolha de um apelido afetivo (o
  // Nordeste usa "Tatuzinho-bola") como pendência do cliente.
  nome: "Gato-palheiro",
  corpo: mascoteCorpo,
  cabeca: mascoteCabeca,
  // MASCULINO, como o Lobo-guará e ao contrário da Onça-pintada.
  //
  // "quase ninguém sabe que eu existo" não é figura de estilo: é o traço da espécie
  // que o banco de cartas inteiro usa como fio (a solução #10 é a câmera escondida,
  // que existe justamente porque o bicho não se deixa ver), e é o que dá sentido ao
  // convite — o aluno vai conhecer um animal que a maioria dos adultos não conhece.
  fala: "Oi, explorador(a)! Sou o Gato-palheiro, o caçador mais discreto do Pampa — quase ninguém sabe que eu existo. Encara os desafios comigo e descubra como proteger o meu campo. Bora?",
  // As duas do ENCERRAMENTO. NÃO CONTAM AS CARTAS — numa trilha de 2 passos o aluno
  // termina com uma só, e é a trilha mais provável de existir. Quem conta é o cromo.
  //
  // Esta foge da fórmula "fico mais tranquila / durmo mais sossegado" das outras
  // duas de propósito: repetida pela terceira vez ela vira gabarito, e aqui há uma
  // frase que só este mascote pode dizer. "Um bicho que quase ninguém vê" fecha o
  // arco aberto na apresentação, e "tem você de olho por ele" devolve ao aluno o
  // papel que a solução #10 descreve.
  falaEncerramento:
    "Olha o que você descobriu no capim alto. Um bicho que quase ninguém vê agora tem você de olho por ele.",
  // O galho de álbum vazio. Não menciona carta, porque a tela não mostra nenhuma.
  falaEncerramentoSemCartas:
    "Você atravessou o meu campo inteiro. Estou orgulhoso, e ainda tenho muito capim alto pra te mostrar por aqui."
};

export const TABULEIRO_SUL = {
  fundo: fundoTabuleiro,
  // Derivados os dois de `BG_sul(pampas).webp`, a segunda arte da pasta: o embaçado
  // é o recorte quadrado e a seleção é a paisagem inteira. Como no Centro-Oeste,
  // esta região veio com duas artes e não três.
  fundoDesfocado,
  fundoSelecao,
  fundoColecao,
  // 1,6519 desde 20/08/2026, e o número mudou DUAS vezes no mesmo dia porque a
  // costura foi refeita duas vezes: 2308 -> 2218 -> 1718 de largura, sempre 1040 de
  // altura. Primeiro aparando 160px de uma ponta, depois escolhendo as DUAS pontas
  // (`cortar_inicio`/`cortar_fim` no catálogo do pipeline). Este campo é o que o
  // `background-size: auto 100%` do CSS usa para saber onde o cenário se repete;
  // esquecê-lo deixa o fundo certo e a repetição errada.
  proporcao: 1.6519,
  // Medido pelo método do CAMINHO, e REMEDIDO a cada mudança de costura — o perfil é
  // da arte COSTURADA e não da arte do ilustrador. 38,6% a 53,2% da altura, e as 192
  // posições caem sobre a vereda.
  //
  // A faixa ficou mais estreita do que era (40,6% a 62,2%) porque o trecho em que a
  // vereda descia até 62% ficou nos 430px aparados do começo. Menos serpente, e o nó
  // continua no leito em todas as posições — conferido também no navegador, onde os
  // nós reais caem sobre a estrada pintada.
  perfilDaEstrada: [
    47.4, 47.9, 47.4, 47.0, 46.8, 46.5, 46.8, 48.0, 48.7, 49.2, 49.2, 48.6,
    48.0, 47.7, 47.6, 47.7, 48.3, 48.6, 48.7, 48.2, 48.2, 48.2, 48.3, 48.5,
    48.7, 48.4, 47.9, 47.6, 47.9, 48.8, 50.2, 51.4, 52.6, 53.0, 53.2, 52.7,
    51.6, 49.6, 47.1, 44.0, 41.2, 39.2, 38.6, 39.7, 41.4, 43.5, 45.3, 46.7
  ]
};

export const CORES_SUL = {
  // O accent é o AZUL DO HORIZONTE, e ele não sai nem da arte do mascote nem do
  // cenário — os dois motivos são os mesmos que levaram o Centro-Oeste ao ipê.
  //
  // O gato-palheiro é bege-acinzentado (#b49c84, medido), que sobre a casca de campo
  // sumiria; e o verde-campo `#84cc16` que o MD do protótipo propunha é a cor DA
  // CENA, o erro que o Norte evitou ao não usar o verde da mata. O que o Pampa tem e
  // as outras quatro regiões não é o CÉU: campo aberto é a metade de baixo de uma
  // paisagem cuja outra metade é horizonte.
  //
  // De quebra, é o accent mais distante dos três que já existem — âmbar no Nordeste,
  // verde no Norte, lilás no Centro-Oeste —, e os quatro aparecem lado a lado na
  // escolha do professor.
  region: "#3a86d6",
  regionStrong: "#1f5896",
  // O degradê da casca vai de PALHA a AREIA DA VEREDA a VERDE-CAMPO, e o meio dele é
  // deliberadamente areia e não verde. A razão é o cartão do professor: ali os
  // degradês das regiões ficam lado a lado, e é o `fundo*` que distingue uma da
  // outra antes de o nome ser lido. Um Sul verde-oliva ficaria irmão do Norte
  // verde-musgo — medido, o meio do degradê dá 47° de matiz aqui contra 81° lá, e
  // são esses 34° que fazem o olho separar os dois cartões.
  //
  // A base fica em 26% de claridade, na régua de 25% das regiões aprovadas, e com
  // saturação 24% contra os 34% do Norte: campo seco, não dossel.
  fundoTopo: "#f4efd8",
  fundoMeio: "#c9ba85",
  fundoBase: "#4a5433",
  // O véu sobre a ilustração embaçada do `::before`.
  veuTopo: "rgba(244, 239, 216, 0.5)",
  veuMeio: "rgba(201, 186, 133, 0.3)",
  veuBase: "rgba(74, 84, 51, 0.45)",
  // O véu radial da escolha do explorador, na paleta desta região.
  veuSelecaoCentro: "rgba(244, 239, 216, 0.42)",
  veuSelecaoMeio: "rgba(201, 186, 133, 0.2)",
  veuSelecaoBorda: "rgba(74, 84, 51, 0.1)",
  // O cromo acompanha o accent, como no Centro-Oeste e ao contrário do Norte: o azul
  // não se confunde com o dourado de PRÊMIO das estrelas dos nós, que é a única
  // razão pela qual o Norte precisou de uma segunda cor.
  //
  // Sobre a pílula branca dá 4,5:1 na borda e 7,3:1 no texto.
  chromeBorda: "#2f78c8",
  chromeTexto: "#1f5896",
  chromeFundo: "#e4eefb"
};

// A FIGURA DO ARCO, na ordem de `cardsRaros` — ameaça primeiro, fecho por último.
//
// É a cena que o aluno vê no fim de leva quando a carta rara NÃO é sorteada (ver
// `cenaDaFase` em ../../../nucleo/recompensaDaFase.js): o mascote cabisbaixo na
// ameaça, de braços erguidos na ajuda, e nenhum prêmio.
//
// SÓ A ARTE, e é o ponto. Nome e fala do arco não estão aqui porque já existem: são
// os da carta que teria caído ali. Uma segunda cópia do texto no descritor
// divergiria da primeira no dia em que alguém ajustasse uma pílula em
// `TemasDaTrilhas/`, que é a fonte de verdade e de onde `gerar-cartas-trilha.py`
// gera `cartas.js`.
//
// LISTA E NÃO `{ ameaca, ajuda }`: quem casa fase rara com momento do arco é o
// alinhamento pelo fim, que trabalha com ÍNDICE. Com um objeto de dois nomes, o
// núcleo teria de saber que o índice 0 se chama "ameaca" — ou seja conheceria a
// narrativa da região, que é exatamente o que ele não faz.
//
// Derivada por `ferramentas-da-trilha/gerar-figuras-trilha.py` (modo `arco`) da arte
// da carta rara: fora a moldura de madeira, e a borda dissolvida.
export const ARCO_SUL = [arcoAmeaca, arcoAjuda];

export const REGIAO_SUL = {
  id: "sul",
  nome: "Sul",
  bioma: "Pampa",
  mascote: MASCOTE_SUL,
  cardsComuns: CARDS_COMUNS_SUL,
  cardsRaros: CARDS_RAROS_SUL,
  arco: ARCO_SUL,
  tabuleiro: TABULEIRO_SUL,
  cores: CORES_SUL
};

export { CARDS_COMUNS_SUL, CARDS_RAROS_SUL, CARDS_SUL } from "./cartas";
